<template>
  <header class="navbar" :class="{ 'navbar-solid': !isHome }">
    <div class="nav-inner">
      <div class="nav-left">
        <img class="logo" src="/logo_full.png" alt="Logo" />
<!--        <span class="brand">汉语能力快速评测</span>-->
        <nav>
          <router-link to="/" class="nav-item" exact-active-class="active">{{ $t('nav.home') }}</router-link>
          <router-link to="/assessment" class="nav-item" active-class="active">{{ $t('nav.assessment') }}</router-link>
          <router-link to="/faq" class="nav-item" active-class="active">{{ $t('nav.faq') }}</router-link>
          <a href="javascript:void(0)" class="nav-item" @click="scrollToFooter">{{ $t('nav.contact') }}</a>
        </nav>
      </div>
      <div class="nav-right">
        <div class="lang-switch" @click="toggleLang">
          <span>{{ currentLang === 'zh' ? 'EN' : '中' }}</span>
        </div>
        <template v-if="loggedIn">
          <span class="online-dot"></span>
          <router-link to="/user/tests" class="user-link">{{ username || $t('nav.personalCenter') }}</router-link>
        </template>
        <router-link v-else to="/login" class="user-link">{{ $t('nav.login') }}</router-link>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      loggedIn: !!localStorage.getItem('token'),
      username: localStorage.getItem('username') || '',
      currentLang: localStorage.getItem('lang') || 'zh'
    }
  },
  computed: {
    isHome() {
      return this.$route.path === '/' || this.$route.path === ''
    }
  },
  watch: {
    '$route'() {
      this.loggedIn = !!localStorage.getItem('token')
      this.username = localStorage.getItem('username') || ''
    }
  },
  methods: {
    scrollToFooter() {
      var footer = document.getElementById('footer')
      if (footer) {
        footer.scrollIntoView({ behavior: 'smooth' })
      }
    },
    toggleLang() {
      this.currentLang = this.currentLang === 'zh' ? 'en' : 'zh'
      this.$i18n.locale = this.currentLang
      localStorage.setItem('lang', this.currentLang)
    }
  }
}
</script>

<style scoped>
/* 默认：首页 - 透明悬浮 */
.navbar {
  background: transparent;
  box-shadow: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}
/* 非首页：白色背景，正常文档流 */
.navbar-solid {
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.nav-inner {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 40px;
}
.nav-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.logo {
  height: 32px;
  width: auto;
  object-fit: contain;
}
.brand {
  font-size: 14px;
  color: #555;
  font-weight: 600;
  margin-right: 24px;
}
nav { display: flex; align-items: center; }
.nav-item {
  text-decoration: none;
  color: #555;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 16px;
  border-radius: 4px;
  transition: all 0.2s;
}
.nav-item.active {
  background: #2b7de9;
  color: #fff;
}
.nav-item:hover:not(.active) { background: #2b7de9; color: #fff; }
.user-link {
  text-decoration: none;
  color: #555;
  font-size: 14px;
  font-weight: 600;
}
.user-link:hover { color: #2b7de9; }
.online-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #10b981;
  margin-right: 6px;
  vertical-align: middle;
}
.nav-right {
  display: flex;
  align-items: center;
  gap: 12px;
}
.lang-switch {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #555;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: #555;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
}
.lang-switch:hover { background: rgba(0,0,0,0.05); border-color: #333; }
@media (max-width: 768px) {
  .nav-inner { padding: 0 16px; }
  .brand { display: none; }
}
</style>
